// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__1DYEW","colMin":"styles_colMin__24Cvy","colCheckbox":"styles_colCheckbox__maM1Z"};